module.exports = __webpack_public_path__ + "img/arrow.1fe3fd21.svg";